import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import SupportContent from '../Components/Support/SupportContent';
import $ from 'jquery';

export default function Support() {
  $('.popover').hide();
  sendGAPageview({ hitType: 'pageview', page: '/Support', title: 'Contact' });

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Support</title>
        <meta name="description" content="Get support for DISGENET." />
      </Helmet>
      <CommonHeader />
      <SupportContent />
    </React.Fragment>
  );
}
